import Vue from 'vue'
import VueRouter from 'vue-router';
import VoucherValidationForm from '@/views/VoucherValidationForm';
import store from '@/store';

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'VoucherValidationForm',
        component: VoucherValidationForm
    },
    {
        path: '/voucher-status',
        name: 'VoucherStatus',
        component: () => import(/* webpackChunkName: "VoucherStatus" */ './views/VoucherStatus'),
        beforeEnter(to, from, next) {
            if (!store.getters.voucherCode) {
                console.log('No voucher available. Redirecting to root');
                next('/');
            }
            else next();
        }
    },
    {
        path: '/booking',
        name: "BookingDetails",
        props: route => ({ code: route.query.code, token: route.query.token }),
        component: () => import(/* webpackChunkName: "BookingDetails" */ './views/BookingDetails'),
        beforeEnter(to, from, next) {
            if (!store.getters.isBookableHotelVoucher && !to.query.token && !to.query.code) {
                console.log('No bookable voucher or token provided. Redirecting to root');
                next('/');
            }
            else next();
        }
    },
    {
        path: '/booking-alternatives',
        name: "BookingAlternatives",
        props: route => ({ code: route.query.code, token: route.query.token }),
        component: () => import(/* webpackChunkName: "BookingAlternatives" */ './views/BookingAlternatives'),
        beforeEnter(to, from, next) {
            if (!to.query.token && !to.query.code) {
                console.log('No token provided. Redirecting to root');
                next('/');
            }
            else next();
        }
    },
    {
        path: '/booking/success',
        name: 'BookingSuccess',
        component: () => import(/* webpackChunkName: "BookingDetails" */ './views/BookingServiceSuccess'),
        beforeEnter (to, from, next) {
            if (!store.state.success) {
                next('/');
            }
            else next();
        }
    },
    {
        path: '*',
        name: 'NotFound',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (to.query.code && to.path !== "/" && !store.getters.hasVoucher) {
        console.log('No validated voucher available. Redirecting to root with code for validation.')
        next({ name: 'VoucherValidationForm', query: { code: to.query.code } })
    }
    else next();
})

export default router
